module.exports = __webpack_public_path__ + "img/nav-theme-dark.da07f9c2.svg";